export const MoveToBottomIcon = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.03711 15.6377L5.89746 13.0361H10.1768L8.03711 15.6377Z"
        fill="white"
      />
      <path
        d="M15.9473 0.0234375V10.9561H14.9473V1.02344H3.56738L1.12695 3.46387V10.9561H0.126953V3.04883L3.15332 0.0234375H15.9473Z"
        fill="white"
      />
      <path
        d="M8.79883 10.9561H7.20312V7.63965H8.79883V10.9561Z"
        fill="white"
      />
      <path d="M4.47852 9.62891H2.88281V6.3125H4.47852V9.62891Z" fill="white" />
      <path d="M13.1182 9.62891H11.5225V6.3125H13.1182V9.62891Z" fill="white" />
      <path
        d="M6.80566 5.64941H5.20996V2.33301H6.80566V5.64941Z"
        fill="white"
      />
      <path d="M10.792 5.64941H9.19629V2.33301H10.792V5.64941Z" fill="white" />
    </svg>
  );
};
